import Logger from './logger'

var isRunning = false
var commands = []
var resolverMap = {}
var lastExecution = null

function initQueue(newQueue) {
  commands = []
  resolverMap = {}
  lastExecution = null
  newQueue.forEach(c => schedule(c))
}

function start() {
  isRunning = true
  _tick()
}
function schedule(newCommand) {
  return new Promise(resolve => {
    Logger.info('scheduler.js - schedule - schedule a new command: ' + JSON.stringify(newCommand))
    commands.unshift(newCommand)
    resolverMap[newCommand] = resolve
    _tick()
  })
}

function _executeCommand(theCommand) {
  return new Promise(resolve => {
    theCommand.execute()

    resolverMap[theCommand]('command result')
    resolve('command completion signal')

    new Promise(() => {
      setTimeout(() => {
        delete resolverMap[theCommand]
        console.log('delete resolverMap')
      }, 1000)
    })
  })
}

function _tick() {
  if (!isRunning) {
    return
  }

  while (commands.length > 0) {
    let currentCommand = commands.pop()

    if (lastExecution) {
      lastExecution = lastExecution.then(() => _executeCommand(currentCommand))
    } else {
      lastExecution = _executeCommand(currentCommand)
    }
  }
}

export default {
  initQueue,
  start,
  schedule,
}
